export const CREATING_USER = "CREATING_USER";
export const UPDATING_USER = "UPDATING_USER";
export const USER_CREATED = "USER_CREATED";
export const USER_UPDATED = "USER_UPDATED";
export const ERROR_USER_CREATE = "ERROR_USER_CREATE";
export const ERROR_USER_UPDATE = "ERROR_USER_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
